export default __webpack_public_path__ + "static/media/masiha.3fad6ac4.jpg";